import { Controller } from "@hotwired/stimulus";

// Toggles filter: show only requirement sections that have unhandled comments.
export default class extends Controller {
  static values = {
    sectionSelector: { type: String, default: ".requirement-section" },
    filterLabel: { type: String, default: "Only unhandled comments" },
    showAllLabel: { type: String, default: "Show all requirements" },
  };

  connect() {
    this.filterActive = false;
    this.updateLabel();
  }

  toggle() {
    this.filterActive = !this.filterActive;
    document.querySelectorAll(this.sectionSelectorValue).forEach((el) => {
      const hasUnhandled = el.dataset.hasUnhandledComments === "true";
      el.classList.toggle("d-none", this.filterActive && !hasUnhandled);
    });
    this.updateLabel();
  }

  updateLabel() {
    if (this.element.tagName === "BUTTON" || this.element.tagName === "A") {
      this.element.textContent = this.filterActive
        ? this.showAllLabelValue
        : this.filterLabelValue;
    }
  }
}
